/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-stream-font[_ngcontent-%COMP%] {\n  font-size: 18px;\n  font-family: helvethaica, sans-serif; }\n\n.icon-btn[_ngcontent-%COMP%] {\n  width: 30px;\n  height: 27px;\n  background: transparent;\n  border-style: none;\n  transition: all 150ms ease-in-out;\n  cursor: pointer;\n  border-radius: 5px; }\n\n.comment-send-button[_ngcontent-%COMP%] {\n  width: 10%;\n  margin-left: 3%; }\n\n.darkblue-color[_ngcontent-%COMP%] {\n  color: darkblue; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/core/comment/comment.component.scss.shim.ngstyle.js.pre-build-optimizer.js